import { lazy } from 'react'

import { useSelector } from 'react-redux'

import { Page } from '@webapp/core/components/Page'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import messages from './messages'

const BudgetCategoryChunk = lazy(() =>
  import('../containers/BudgetCategoryView').then(({ BudgetCategoryView }) => ({
    default: BudgetCategoryView,
  }))
)

export const BudgetCategoryPage = () => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(
        isFlexibleSpendTrackingEnabled
          ? messages.manageBudgetsTitle
          : messages.manageBudgetCategoryTitle
      )}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.settingsPageTitle),
          link: url('SettingsPage'),
        },
        {
          name: intl.formatMessage(
            isFlexibleSpendTrackingEnabled
              ? messages.manageBudgetsTitle
              : messages.manageBudgetCategoriesPageTitle
          ),
        },
      ]}
    >
      <BudgetCategoryChunk />
    </Page>
  )
}
